import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { isEmpty } from "lodash";
import { useCallback, useEffect, useState } from "react";
import SwitchButton from "src/components/switch-button/switch";
import styles from "src/pages/dashboard/forms/buyforms/buyform.module.scss";
import { DECIMAL_LENGTH_LIMIT, OPTIONS_PRODUCT, } from "src/utils/constant";
import { getPreferences, getSegmentAndProductType, handleDecimalLimit, intComma, } from "src/utils/methods";
import { nearestNumberRoundOff } from "../../../../../utils/methods";
const { REACT_APP_ENV } = process.env;
const CoverBracketOrderForm = ({ scripData, modifyOrderType, formType, priceType, price, isFormValid, setCoverBracketFormData, fetchSetting, }) => {
    // const stopLossPriceInputRef = useRef<HTMLInputElement>(null);
    const [addStoplossExpand, setAddStoplossExpand] = useState(false);
    const [isMarketToggleVisible, setMarketToggleVisible] = useState(true);
    const [stopLossPriceType, setStopLossPriceType] = useState("market"); //market , limit
    const [targetPrice, setTargetPrice] = useState("0");
    const [tpErrorMessage, setTpErrorMessage] = useState("");
    const [stopLossTriggerPrice, setStopLossTriggerPrice] = useState("0");
    const [tralingStopLoss, setTralingStopLoss] = useState("0");
    const [tslErrorMessage, setTslErrorMessage] = useState("");
    const [sltErrorMessage, setSltErrorMessage] = useState("");
    const [slpErrorMessage, setSlpErrorMessage] = useState("");
    const [stopLossPrice, setStopLossPrice] = useState("0");
    const setStopLossPriceTypeCallback = (newValue) => {
        setStopLossPriceType(newValue);
    };
    const onAddStoplossChange = useCallback((isChecked) => {
        setAddStoplossExpand(isChecked);
    }, []);
    const setStopLossTriggerCallback = useCallback((newValue) => {
        if (Number(newValue) >= 0) {
            setStopLossTriggerPrice(handleDecimalLimit(newValue, DECIMAL_LENGTH_LIMIT));
        }
    }, []);
    const setStopLossPriceCallBack = (event) => {
        setStopLossPrice(handleDecimalLimit(event, DECIMAL_LENGTH_LIMIT));
        let errorMessage = "";
        if (isEmpty(event)) {
            errorMessage = "Stoploss cannot be empty";
        }
        else if (event == "0") {
            if (stopLossPriceType == "market") {
                errorMessage = "";
            }
            else {
                errorMessage = "Stoploss price cannot be zero";
            }
        }
        if (modifyOrderType != "PROFIT")
            setSlpErrorMessage(errorMessage);
    };
    const setTargetPriceCallBack = useCallback((event) => {
        setTargetPrice(handleDecimalLimit(event, DECIMAL_LENGTH_LIMIT));
    }, []);
    const setTralingStopLossCallBack = useCallback((event) => {
        setTralingStopLoss(handleDecimalLimit(event, DECIMAL_LENGTH_LIMIT));
    }, []);
    const getLabelForStopLossPanel = useCallback(() => {
        let labelName = "Add StopLoss";
        if (addStoplossExpand) {
            if ((isEmpty(targetPrice) || parseFloat(targetPrice) == 0) &&
                (scripData.orderData ? scripData.orderData.DelvIntra != "S" : true)) {
                labelName = "Add StopLoss (Cover order)";
            }
            else {
                labelName = "Add StopLoss (Bracket order)";
            }
        }
        else {
            labelName = "Add StopLoss (Cover/Braket order)";
        }
        return labelName;
    }, [addStoplossExpand, targetPrice]);
    const isFormValidCallback = () => {
        if (!isEmpty(tpErrorMessage)) {
            return false;
        }
        else if (addStoplossExpand) {
            if (slpErrorMessage != "") {
                return false;
            }
            else if (sltErrorMessage != "") {
                return false;
            }
            else if (((parseFloat(stopLossPrice) == 0 && stopLossPriceType == "limit") ||
                parseFloat(stopLossTriggerPrice) == 0) &&
                modifyOrderType != "PROFIT") {
                return false;
            }
            else if ((isEmpty(targetPrice) || parseFloat(targetPrice) == 0) &&
                modifyOrderType == "PROFIT") {
                return false;
            }
            else {
                return true;
            }
        }
        else {
            return true;
        }
    };
    useEffect(() => {
        var _a, _b, _c, _d, _e;
        //console.log("Hiii", addStoplossExpand);
        if (addStoplossExpand &&
            !((_a = scripData.openedFrom) === null || _a === void 0 ? void 0 : _a.includes("Ideas")) &&
            !((_b = scripData.openedFrom) === null || _b === void 0 ? void 0 : _b.includes("Quick Option trade")) &&
            !((_c = scripData.openedFrom) === null || _c === void 0 ? void 0 : _c.includes("re-order")) &&
            !((_d = scripData.openedFrom) === null || _d === void 0 ? void 0 : _d.includes("square-off")) &&
            !((_e = scripData.openedFrom) === null || _e === void 0 ? void 0 : _e.includes("Footer Order"))) {
            const myPreferences = getPreferences();
            const bracketType = myPreferences.orderSettings.bracketType;
            const profitTrigger = myPreferences.orderSettings.profitTrigger;
            const sltrigger = myPreferences.orderSettings.sltrigger;
            //((LTP or limit * input %)- LTP or limit ) for buy and sell it will ((LTP or limit * input %)+ LTP or limit
            const stopLossCalc = formType == "BUY"
                ? bracketType == "percent"
                    ? Number(scripData.lastTradePrice) * (1 - sltrigger / 100)
                    : Number(scripData.lastTradePrice) - sltrigger
                : bracketType == "percent"
                    ? Number(scripData.lastTradePrice) * (1 + sltrigger / 100)
                    : Number(scripData.lastTradePrice) + sltrigger;
            if (Number(stopLossCalc) >= 0) {
                const val = nearestNumberRoundOff(stopLossCalc);
                setStopLossTriggerPrice(intComma(val.toString()).replace(/,/g, ""));
            }
            const profitCalc = formType == "BUY"
                ? bracketType == "percent"
                    ? Number(scripData.lastTradePrice) * (1 + profitTrigger / 100)
                    : Number(scripData.lastTradePrice) + Number(profitTrigger)
                : bracketType == "percent"
                    ? Number(scripData.lastTradePrice) * (1 - profitTrigger / 100)
                    : Number(scripData.lastTradePrice) - Number(profitTrigger);
            if (profitTrigger) {
                const val = nearestNumberRoundOff(profitCalc);
                setTargetPrice(intComma(val.toString()).replace(/,/g, ""));
            }
            // console.log("stopLossCalc",stopLossCalc,profitCalc)
        }
        //console.log(price, myPreferences.orderSettings);
    }, [addStoplossExpand]);
    useEffect(() => {
        if (stopLossPriceType == "market") {
            setStopLossPriceCallBack("0");
        }
    }, [stopLossPriceType]);
    useEffect(() => {
        setCoverBracketFormData({
            addStoplossExpand,
            stopLossPrice,
            stopLossTriggerPrice,
            targetPrice,
            tralingStopLoss,
        });
        isFormValid(isFormValidCallback());
    }, [
        addStoplossExpand,
        stopLossPrice,
        stopLossTriggerPrice,
        targetPrice,
        modifyOrderType,
        slpErrorMessage,
        sltErrorMessage,
        tpErrorMessage,
        tralingStopLoss,
        stopLossPriceType,
    ]);
    useEffect(() => {
        if (scripData.orderData) {
            const DelvIntra = scripData.orderData.DelvIntra;
            if (DelvIntra == "I" || DelvIntra == "S" || DelvIntra == "C") {
                if (DelvIntra == "S" || DelvIntra == "C") {
                    setAddStoplossExpand(true);
                    setStopLossPriceCallBack(scripData.orderData.SMOSLLimitRate + "");
                    if (scripData.orderData.SMOSLLimitRate > 0) {
                        setStopLossPriceTypeCallback("limit");
                    }
                    setStopLossTriggerCallback(scripData.orderData.SMOSLTriggerRate + "");
                    setTargetPriceCallBack(scripData.orderData.SMOProfitRate + "");
                    setTralingStopLossCallBack(scripData.orderData.SMOTrailingSL + "");
                    if (scripData.orderFor == "M") {
                        if (DelvIntra == "S") {
                            if (scripData.orderData.SMOProfitRate != 0 &&
                                scripData.orderData.SMOSLTriggerRate != 0) {
                                // return Constants.ORDERTYPE.BRACKET_INITIAL;
                            }
                            else if (scripData.orderData.WithSL == "Y") {
                                setStopLossPriceCallBack(scripData.orderData.Rate + "");
                                if (scripData.orderData.Rate > 0) {
                                    setStopLossPriceTypeCallback("limit");
                                }
                                setStopLossTriggerCallback(scripData.orderData.SLTriggerRate + "");
                                // return Constants.ORDERTYPE.BRACKET_SL;
                            }
                            else if (scripData.orderData.WithSL == "N") {
                                setTargetPriceCallBack(scripData.orderData.Rate + "");
                                // return Constants.ORDERTYPE.BRACKET_PROFIT;
                            }
                        }
                        else if (DelvIntra == "C") {
                            if (scripData.orderData.SMOSLTriggerRate != 0) {
                                // return Constants.ORDERTYPE.COVER_INITIAL;
                            }
                            else if (scripData.orderData.WithSL == "Y") {
                                setStopLossPriceCallBack(scripData.orderData.Rate + "");
                                if (scripData.orderData.Rate > 0) {
                                    setStopLossPriceTypeCallback("limit");
                                }
                                setStopLossTriggerCallback(scripData.orderData.SLTriggerRate + "");
                                // return Constants.ORDERTYPE.COVER_SL;
                            }
                        }
                        else {
                        }
                    }
                }
                else {
                    if (scripData.orderData.SLTriggerRate != 0) {
                        setStopLossTriggerCallback(scripData.orderData.SLTriggerRate + "");
                    }
                }
            }
        }
        const scripTypeObj = getSegmentAndProductType(scripData.name, scripData.exchange, scripData.exchangeType);
        if (scripTypeObj.productType == OPTIONS_PRODUCT) {
            setMarketToggleVisible(false);
            setStopLossPriceTypeCallback("limit");
        }
        else {
            setMarketToggleVisible(true);
        }
        // getSliceLimitCallback();
    }, [scripData]);
    const setStopLossPriceErrorMessageCallBack = () => {
        let errorMessage = "";
        let localBuySell = formType;
        //For stoploss order modification
        if (modifyOrderType == "STOPLOSS") {
            localBuySell = formType == "BUY" ? "SELL" : "BUY";
        }
        if (modifyOrderType == "PROFIT") {
        }
        else if (isEmpty(stopLossPrice)) {
            errorMessage = slpErrorMessage;
        }
        else if (!isEmpty(sltErrorMessage) || isEmpty(stopLossTriggerPrice)) {
            errorMessage = "";
        }
        else if (stopLossPrice == "0") {
            if (stopLossPriceType == "market") {
                errorMessage = "";
            }
            else {
                errorMessage = slpErrorMessage;
            }
        }
        else if (localBuySell == "BUY") {
            if (parseFloat(stopLossTriggerPrice) <= parseFloat(stopLossPrice)) {
                errorMessage =
                    "Stoploss price should be less than stoploss trigger price";
            }
            else {
                errorMessage = "";
            }
        }
        else if (localBuySell == "SELL") {
            if (parseFloat(stopLossTriggerPrice) >= parseFloat(stopLossPrice)) {
                errorMessage =
                    "Stoploss price should be greater than stoploss trigger price";
            }
            else {
                errorMessage = "";
            }
        }
        else {
        }
        setSlpErrorMessage(errorMessage);
        // return errorMessage;
    };
    const setSltErrorMessageCallback = () => {
        let errorMessage = "";
        if (modifyOrderType != "STOPLOSS" && modifyOrderType != "PROFIT") {
            if (isEmpty(stopLossTriggerPrice)) {
                errorMessage = "Stoploss trigger cannot be empty";
            }
            else if (!isEmpty(stopLossPrice) &&
                Number(stopLossPrice) > 0 &&
                stopLossTriggerPrice == "0") {
                errorMessage = "Stoploss trigger cannot be zero";
            }
            else if (priceType == "limit") {
                if (formType == "BUY" &&
                    parseFloat(stopLossTriggerPrice) >= parseFloat(price)) {
                    errorMessage = "Stoploss trigger cannot be greater than price";
                }
                else if (formType == "SELL" &&
                    parseFloat(stopLossTriggerPrice) <= parseFloat(price)) {
                    errorMessage = "Stoploss trigger cannot be less than price";
                }
            }
        }
        setSltErrorMessage(errorMessage);
    };
    const setTpErrorMessageCallback = () => {
        let errorMessage = "";
        if (isEmpty(targetPrice)) {
            errorMessage = "Target price cannot be empty";
        }
        else if (parseFloat(targetPrice) == 0) {
        }
        else if (priceType == "limit" &&
            modifyOrderType != "PROFIT" &&
            modifyOrderType != "STOPLOSS") {
            if (formType == "BUY" && parseFloat(targetPrice) < parseFloat(price)) {
                errorMessage = "Target price should be greater than price";
            }
            else if (formType == "SELL" &&
                parseFloat(targetPrice) > parseFloat(price)) {
                errorMessage = "Target price should be less than price";
            }
        }
        setTpErrorMessage(errorMessage);
    };
    useEffect(() => {
        setStopLossPriceErrorMessageCallBack();
    }, [stopLossPrice, stopLossTriggerPrice, stopLossPriceType, sltErrorMessage]);
    useEffect(() => {
        setSltErrorMessageCallback();
        setTpErrorMessageCallback();
    }, [
        formType,
        stopLossPrice,
        stopLossTriggerPrice,
        price,
        priceType,
        targetPrice,
    ]);
    return (_jsxs("div", Object.assign({ className: `${styles.addStoplossPanel}` }, { children: [_jsxs("div", Object.assign({ className: "d-flex justify-content-between align-items-end" }, { children: [_jsx("label", Object.assign({ className: `${styles.switchTitle}` }, { children: getLabelForStopLossPanel() })), _jsx(SwitchButton, { onChange: onAddStoplossChange, checked: addStoplossExpand, disabled: scripData.orderFor == "M" })] })), addStoplossExpand && (_jsxs("div", Object.assign({ className: `${styles.stopLossPrice} mt-3` }, { children: [_jsxs("div", Object.assign({ className: `${styles.stopLossLeft}` }, { children: [_jsx("div", Object.assign({ className: "d-flex justify-content-between align-items-center h-15" }, { children: _jsx("label", { children: "Stoploss Trigger" }) })), _jsx("input", { type: "number", placeholder: "Stoploss trigger price", className: `${styles.formControl} ${sltErrorMessage && styles.inputError} mt-2`, "aria-label": "", onWheel: (event) => {
                                    event.target.blur();
                                }, value: stopLossTriggerPrice, step: scripData.exchangeType == "U" ? "0.0001" : "0.01", disabled: modifyOrderType == "PROFIT", onChange: (event) => setStopLossTriggerCallback(event.target.value) }), _jsxs("p", Object.assign({ className: `${styles.errorText} align-items-start mt-1`, hidden: sltErrorMessage == "" }, { children: [sltErrorMessage && _jsx("span", { className: "errorIcon me-1" }), sltErrorMessage] }))] })), _jsxs("div", Object.assign({ className: `${styles.stopLossRight}` }, { children: [_jsxs("div", Object.assign({ className: "d-flex justify-content-between align-items-end h-15" }, { children: [_jsx("label", { children: "Stoploss Price" }), isMarketToggleVisible && (_jsxs("div", Object.assign({ className: `${styles.marketLimit}` }, { children: [_jsx("span", Object.assign({ className: stopLossPriceType == "market" ? styles.active : "", onClick: () => setStopLossPriceTypeCallback("market") }, { children: "Market" })), _jsx("span", Object.assign({ className: stopLossPriceType == "limit" ? styles.active : "", onClick: () => setStopLossPriceTypeCallback("limit") }, { children: "Limit" }))] })))] })), _jsx("div", Object.assign({ className: "input-group-bk mt-2", onClick: () => {
                                    setStopLossPriceTypeCallback("limit");
                                } }, { children: _jsx("input", { type: "number", placeholder: "Stoploss price", onWheel: (event) => {
                                        event.target.blur();
                                    }, value: stopLossPrice, disabled: modifyOrderType == "PROFIT" || stopLossPriceType == "market", className: `${styles.formControl} ${slpErrorMessage && styles.inputError}`, "aria-label": "", step: scripData.exchangeType == "U" ? "0.0001" : "0.01", onChange: (event) => {
                                        setStopLossPriceCallBack(event.target.value);
                                    } }) })), _jsxs("p", Object.assign({ className: `${styles.errorText} mt-1`, hidden: slpErrorMessage == "" }, { children: [slpErrorMessage && _jsx("span", { className: "errorIcon me-1" }), slpErrorMessage] }))] }))] }))), addStoplossExpand && (_jsxs("div", Object.assign({ className: `${styles.stopLossPrice} mt-3` }, { children: [_jsxs("div", Object.assign({ className: `${styles.stopLossLeft}` }, { children: [_jsx("label", { children: "Trailing StopLoss (Optional)" }), _jsx("input", { type: "number", placeholder: "Trailing stoploss", onWheel: (event) => {
                                    event.target.blur();
                                }, className: `${styles.formControl} ${tslErrorMessage && styles.inputError} form-controlBKp mt-1`, "aria-label": "", value: tralingStopLoss + "", disabled: modifyOrderType == "PROFIT", step: scripData.exchangeType == "U" ? "0.0001" : "0.01", onBlur: () => {
                                    isEmpty(tralingStopLoss) ? setTralingStopLossCallBack("0") : "";
                                }, onChange: (event) => {
                                    setTralingStopLossCallBack(event.target.value);
                                } }), _jsxs("p", Object.assign({ className: `${styles.errorText} mt-1`, hidden: tslErrorMessage == "" }, { children: [tslErrorMessage && _jsx("span", { className: "errorIcon me-1" }), tslErrorMessage] }))] })), _jsxs("div", Object.assign({ className: `${styles.stopLossRight}` }, { children: [_jsx("label", { children: "Target Price (Optional)" }), _jsx("input", { type: "number", placeholder: "Target price", className: `${styles.formControl} ${tpErrorMessage && styles.inputError} form-controlBkp mt-1`, onWheel: (event) => {
                                    event.target.blur();
                                }, "aria-label": "", disabled: modifyOrderType == "STOPLOSS", value: targetPrice, step: scripData.exchangeType == "U" ? "0.0001" : "0.01", onBlur: () => {
                                    isEmpty(targetPrice) ? setTargetPriceCallBack("0") : "";
                                }, onChange: (event) => {
                                    setTargetPriceCallBack(event.target.value);
                                } }), _jsxs("p", Object.assign({ className: `${styles.errorText} mt-1`, hidden: tpErrorMessage == "" }, { children: [tpErrorMessage && _jsx("span", { className: "errorIcon me-1" }), tpErrorMessage] }))] }))] })))] })));
};
export default CoverBracketOrderForm;
